export const PROVIDER_ID = typeof TWIG_PROVIDER_ID !== 'undefined' ? TWIG_PROVIDER_ID : -1; // eslint-disable-line
export const WEB_FORM_DATA_ROW = typeof TWIG_WEB_FORM_DATA_ROW !== 'undefined' ? TWIG_WEB_FORM_DATA_ROW : -1; // eslint-disable-line
export const PROVIDER_NAME = typeof TWIG_PROVIDER_NAME !== 'undefined' ? TWIG_PROVIDER_NAME : "Insure Apps"; // eslint-disable-line
export const PROVIDER_COLOR = typeof TWIG_PROVIDER_COLOR !== 'undefined' && typeof TWIG_PROVIDER_COLOR !== '' ? TWIG_PROVIDER_COLOR : "#2f558a"; // eslint-disable-line
export const PARENT_PROVIDER_NAME = typeof TWIG_PARENT_PROVIDER_NAME !== 'undefined' && typeof TWIG_PARENT_PROVIDER_NAME !== '' ? TWIG_PARENT_PROVIDER_NAME : ""; // eslint-disable-line

export const GOOGLE_MAP_API = 'AIzaSyCyG8n8XOzWSP13XfiS3xiI3D2wL-iVNLA';

export const BASE_URL = 'https://manager.insureapps.co.uk/api';
export const DVLA_LOOKUP = `/dvla/submit`;
export const REPORT_SUBMIT_FINAL = `/report/submit-final`;
export const REPORT_SUBMIT = `/report/submit`;
export const DAMAGE_DATA = `/damage/get_data`;
export const HOWDEN_CLAIM_NUMBERS = '/app_user/anston_lark_phone_number';